<template lang="pug">
.sidebar
  #preloader(v-if="gameLaunching")
    #loader
  .logo
    router-link(to='/')
      img(src='assets/img/logo.png')
  //- .button-area(:class="{'after-log' : isLoggedIn}")
  .button-area.after-log.custom-log
    template(v-if="!isLoggedIn")
      //- a.btn-login(href='javascript:void(0)' @click="openLogModal()") {{$t('ui.login')}}
      //- a.btn-register(href='javascript:void(0)' @click="openRegisterModal()") {{$t('ui.register')}}
    template(v-else)
      .profile.custom-hide
        i.fa-solid.fa-circle-user(v-if="getAvatar===''")
        img(v-else :src="getAvatar")
      .text-left.custom-hide.pointer(@click="$helpers.redirect('deposit')")
        span.username.float-start {{accountID}}
        br
        span.balance.float-start PHP {{ $numeral($store.getters.balance).format("0,0.00") }}
          //- i.fa-solid.fa-eye
    //- img.lvl-img.custom-hide.pointer(v-if="getCurrentLevel!==''" :src="'assets/img/level/'+getCurrentLevel+'.png'" @click="gamification()")
    img.lvl-img.custom-hide.pointer.mx-1(v-if="getVip!==''" :src="'assets/img/vip/'+getVip+'.png'" @click="$helpers.redirect('vip')")
    //- .u-lvl.text-white.ms-2 Rookie
    .dropdown.lang
      button#lang.btn.dropdown-toggle(type='button' data-bs-toggle='dropdown' aria-expanded='false')
        a(href='javascript:void(0)')
          img(:src="'assets/img/lang-'+getLanguage+'.png'")
      ul.dropdown-menu(aria-labelledby='lang')
        li
          a(href='javascript:void(0)' @click="setLanguage('ph')")
            img(src='assets/img/lang-ph.png')
        li
          a(href='javascript:void(0)' @click="setLanguage('en')")
            img(src='assets/img/lang-en.png')
    //- button.btn(type='button')
      //- i.fa-solid.fa-bars
  .reward 
    template(v-if="isLoggedIn")
      div
        router-link(to="inbox")
          img(src='assets/img/inbox.png')
      div
        router-link(to='vip' :class="{'aaa': currentPath==='/vip'}")
          img(src='assets/img/vip.png')
      div
        a(href="javascript:void(0)" @click="gamification()")
          img(src='assets/img/missions.png')
    template(v-else)
      div
        a(href="javascript:void(0)" @click="$helpers.openModal('#logModal')")
          img(src='assets/img/inbox.png')
      div
        a(href="javascript:void(0)" @click="$helpers.openModal('#logModal')")
          img(src='assets/img/vip.png')
      div
        a(href="javascript:void(0)" @click="$helpers.openModal('#logModal')")
          img(src='assets/img/missions.png')
    div
      router-link(to="ambassador")
        img(src='assets/img/m/menu/ambasaddor.png')
  .nav
    ul
      li
        router-link.s4(to='promotions' :class="{'aaa': currentPath==='/promotions'}")
          img(src='assets/img/menu/m-promo.png')
          span {{$t('ui.promotion')}}
      //- li(v-if="isLoggedIn")
        router-link.s4(to='profile' :class="{'aaa': currentPath==='/profile'}")
          img(src='assets/img/menu/m-profile.png')
          span {{$t('ui.profile')}}
      li.c-height(v-if="isLoggedIn")
        router-link.s4(to='deposit' :class="{'aaa': currentPath==='/deposit'}")
          .d-flex.align-items-center
            img(src='assets/img/menu/m-wallet.png')
            span {{$t('ui.deposit')}} / {{$t('ui.withdrawal')}}
      li(v-if="isLoggedIn")
        router-link.s4(to='statement' :class="{'aaa': currentPath==='/statement'}")
          img(src='assets/img/menu/m-statement.png')
          span {{$t('ui.statement')}}
      li(v-if="isLoggedIn")
        router-link.s4(to='setting' :class="{'aaa': currentPath==='/setting'}")
          img(src='assets/img/menu/m-setting.png')
          span {{$t('ui.setting')}}
      hr
      li
        router-link.ggt(to="/" :class="{'aaa': currentPath==='/'}")
          img(src='assets/img/menu/m-hot.png')
          span Hot
      li
        router-link.ggt(to="slot" :class="{'aaa': currentPath==='/slot'}")
          img(src='assets/img/menu/m-epic.gif')
          span.text-capitalize {{$t('ui.slots')}}
      //- li
        router-link(to="slot")
          img(src='assets/img/menu/m-promo.png')
          span.text-capitalize {{$t('ui.slot')}}
      li
        router-link(to="casino" :class="{'aaa': currentPath==='/casino'}")
          img(src='assets/img/menu/m-live.png')
          span.text-capitalize {{$t('ui.live')}}
      li
        router-link(to="table" :class="{'aaa': currentPath==='/table'}")
          img(src='assets/img/menu/m-poker.png')
          span Poker
      li
        router-link(to="bingo" :class="{'aaa': currentPath==='/bingo'}")
          img(src='assets/img/menu/m-bingo.png')
          span Bingo
      li
        router-link(to="hash" :class="{'aaa': currentPath==='/hash'}")
          img(src='assets/img/menu/m-hash.png')
          span.text-capitalize Hash Game
      li
        //- a.ggt(href='javascript:void(0)' @click="launchSabong")
        router-link(to="sabong" :class="{'aaa': currentPath==='/sabong'}")
          img(src='assets/img/menu/m-cock.png')
          span Sabong
      li(v-if="isLoggedIn")
        a.ggt(href='javascript:void(0)' @click="launchWbet")
          img(src='assets/img/menu/m-sport.png')
          span Sports
        //- router-link.ggt(to="/launchWbet" target="_blank")
          img(src='assets/img/menu/m-sport.png')
          span Sports
      li(v-else)
        a.ggt(href="javascript:void(0)" @click="$helpers.openModal('#logModal')")
          img(src='assets/img/menu/m-sport.png')
          span Sports
      li
        router-link(to="fishing" :class="{'aaa': currentPath==='/fishing'}")
          img(src='assets/img/menu/m-fish.png')
          span.text-capitalize {{$t('ui.fishing')}}
      li
        router-link(to="freeplay" :class="{'aaa': currentPath==='/freeplay'}")
          img(src='assets/img/menu/m-demo.png')
          span Demo Play
      li
        router-link(to="review" :class="{'aaa': currentPath==='/review'}")
          img(src='assets/img/menu/m-review.png')
          span {{$tc('ui.review')}}
      //- li
      //-   a.s3(href='#')
      //-     img(src='assets/img/event-icon.png')
      //-     span Event
      hr
      li
        router-link(to="news" :class="{'aaa': currentPath==='/news'}")
          img(src='assets/img/menu/m-news.png')
          span.text-capitalize News
      li
        router-link.s4(to="livestream" :class="{'aaa': currentPath==='/livestream'}")
          img(src='assets/img/menu/m-video.png')
          span Live Stream
      li
        router-link.s4(to="contactUs" :class="{'aaa': currentPath==='/contactUs'}")
          img(src='assets/img/menu/m-follow.png')
          span {{$t('ui.follow_us')}}
      li
        router-link.s1(to="referral" :class="{'aaa': currentPath==='/referral'}")
          img(src='assets/img/menu/m-refer1.png')
          span {{$t('ui.referral')}}
  .logout-area(v-if="isLoggedIn")
    a.btn-logout(href='javascript:void(0)' @click="logout") {{$t('ui.logout')}}
</template>
<script>
export default {
  data() {
    return {
      feedback: {
        success: true,
        status: ""
      },
      refreshBalance: null,
      loading:false,
      gameLaunching:false,
      mobileDevice: false,
      currentPath:"",
      refreshVip:null,
      // counter: 0,
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    getDisplayName() {
      return this.$store.getters.username || this.$store.getters.accountID
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    getBankList() {
      return this.$store.getters.bankList
    },
    inboxList(){
      return this.$store.state.user.inbox
    },
    getAnnBefore() {
      return this.$store.state.user.annBeforeLog
    },
    getAvatar(){
      return this.$store.getters.getAvatar
    },
    getCurrentLevel(){ //smartico
      return this.$store.getters.getCurrentLevel
    },
    getVip(){
      return this.$store.state.user.vip
    }
  },
  watch:{
    isLoggedIn(newState, oldState){
      if(newState){
        this.firstBalance()
        this.getMemberEwallet()
        this.getMemberBankList()
        this.getFavlist()
        // this.loginLog()
      }
    },
    $route (to, from){
      this.currentPath = to.path
    }
  },
  created(){
    this.checkAnn()
  },
  mounted(){
    this.getMobile()
    this.currentPath = this.$router.currentRoute.path
    if (this.$store.getters.isLoggedIn) {
      this.getBalance()
      this.getMemberVip()
      // this.getInboxList()
    }
    this.refreshBalance = setInterval(() => {
      if (this.$store.getters.isLoggedIn) {
        this.getBalance()
        // this.getInboxList()
      }
    }, 8000)
    this.refreshVip = setInterval(() => {
      if (this.$store.getters.isLoggedIn) {
        this.getMemberVip()
        // this.getInboxList()
      }
    }, 15000)
  },
  beforeDestroy: function() {
    clearInterval(this.refreshBalance)
    clearInterval(this.refreshVip)
    // clearInterval(this.refreshInbox)
    // clearInterval(this.continueRefreshInbox)
  },
  methods:{
    gamification(){
      // console.log('here', window._smartico)
      // window._smartico.dp('dp:gf');
      _smartico.dp('dp:gf')
    },
    rules(){
      // _smartico.dp("dp:gf_section&id=91")  //rules
      _smartico.dp("dp:gf_saw") //wheel
    },
    eventAction(){
      if(this.isLoggedIn){
        $("#leaderboard-modal").modal("show")
        // window._smartico.showWidget('ui-widget', { iframe: 'testIframe', zoom: 1, height: 'auto', wuuid: '100005/79d12290-d465-11ee-9aa0-0228c1221b89', id: 2} )
        
      }else{
        this.openLogModal()
      }
    },
    checkAnn(){
      this.$store
        .dispatch("user/getAnnBanner")
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            if(response.annBeforeLog === true){
              if(!this.isLoggedIn){
                $("#annModal").modal("show");
              }
            }
          } else {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }       
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this;
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
        });
      // if(!this.$store.getters.isLoggedIn){
      //   if(this.$store.state.user.annBeforeLog === true){
      //     $("#modal-banner").modal("show");
      //   }
      // }
    },
    getMemberEwallet(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberEwallet", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    getMemberBankList() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberBankList", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
							
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    getFavlist(){
      if (this.sessionToken) {
				var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getFavlist", { account_id, auth_token})
          .then(response => {
            if (response.success == true) {
							// console.log(response)
            } else {             
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    openLogModal(){
      $("#logModal").modal("show")
    },
    openRegisterModal(){
      $("#regModal").modal("show")
    },
    setLanguage(payload) {
      this.$store.dispatch("user/setLanguage", payload)
    },
    firstBalance(){
      var vm = this
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    getBalance() {
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getBalance", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }              
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }  
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    getMemberVip(){
      if (this.sessionToken) {
        this.loading = true
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberVip", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
            this.loading = false
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.loading = false
          })
      }
    },
    getMobile() {
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobileDevice = true
      }else{
        this.mobileDevice = false
      }
    },
    launchWbet(){
      if (this.sessionToken) {
        var type = (this.mobileDevice ? 2 : 1).toString()
        this.$router.push({
          name:"lobby",
          params:{
            "source": "",
            "type": type,
            "provider": "",
            "code": "SPORTS",
            "id": "",
            "name": "SPORTS"
          }
        }).catch(error =>{})
				// var vm = this
        // let player_id = this.accountID
        // let auth_token = this.sessionToken
        // let type = (this.mobileDevice ? 2 : 1).toString()
        // let lang_code = this.getLanguage
        // this.$store
        //   .dispatch("user/launchWbet", { player_id, auth_token,type, lang_code })
        //   .then(response => {
        //     if (response.success == true) {
				// 			setTimeout(() => {
				// 				window.open(response.data, "_blank")
				// 			})
        //     } else {    
        //       if((typeof response.status) != 'object'){
        //         this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);    
        //       }
        //     }
        //   })
        //   .catch(response => {
        //     if((typeof response.status) != 'object'){
        //       if(response.status === 'free_credit_detected'){
        //         this.$swal({
        //           title: vm.$tc("ui.attention"),
        //           text: vm.$tc("message.list.free_credit_detected"),
        //           showCancelButton: true,
        //           type: "info",
        //           confirmButtonText: vm.$tc("ui.ok"),
        //           cancelButtonText: vm.$tc("ui.deposit"),
        //         }).then(result => {
        //           if (result.value) {
        //             vm.$router.push("/").catch(error =>{})
        //           } else if (result.dismiss) {
        //             if(result.dismiss === 'cancel'){
        //               vm.$router.push("/deposit").catch(error =>{})
        //             }
        //           }
        //         });
        //       }else{
        //         this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
        //       } 
        //     }
        //   });
      }else{
				$("#logModal").modal("show")
			}
    },
    logout() {
      window._smartico_user_id = null;
      window._smartico_language = null;
      this.$store
        .dispatch("user/logout")
        .catch(err => {})
    },
  }
}
</script>
<style lang="scss" scoped>
.sidebar{
  z-index: 3;
  background: black;
}
.custom-log{
  .btn-login{
    padding: 0 6px;
  }
  .btn-register{
    padding: 0 6px;
  }
  @media(min-width: 681px){
    display: block;
  } 
}
.custom-hide{
  @media(min-width: 681px){
    display: none !important;
  }
}
.custom-display{
  display: none !important;
  @media(min-width: 681px){
    display: block;
  }
}
.mobile-statement{
  min-width: 0 !important;
}
</style>